import React from "react";
import Loadable from "react-loadable";
import { BrowserRouter as Router, Route } from "react-router-dom";

import SignUp from "./SignUp";
import SignIn from "./SignIn";

// import About from "./About";
import withSnippet from "../hoc/withSnippet";
import PasswordForget from "./PasswordForget";
import PasswordChange from "./PasswordChange";
import * as routes from "../constants/routes";
import { PageWrapper } from "../styles/components";
// import AddCategoryPage from "./AddCategoryPage";
// import CategoryDetailPage from "./CategoryDetailPage";
import withLayout from "../styles/hoc/withLayout";

const loading = () => <h1>Loading...</h1>;

const HowTo = Loadable({ loader: () => import ("./HowTo"), loading });
const Landing = Loadable({ loader: () => import ("./Landing"), loading });
const About = Loadable({ loader: () => import ("./About"), loading });
const Home = Loadable({ loader: () => import ("./Home"), loading });
const CategoryDetailPage = Loadable({ loader: () => import ("./CategoryDetailPage"), loading });
const AddCategoryPage = Loadable({ loader: () => import ("./AddCategoryPage"), loading });
const CategoryListPage = Loadable({ loader: () => import ("./CategoryListPage"), loading });
const AddSnippet = Loadable({ loader: () => import ("./AddSnippet"), loading });
const MySnippets = Loadable({ loader: () => import ("./MySnippets"), loading });
const Account = Loadable({ loader: () => import ("./Account"), loading });
const EditSnippet = Loadable({ loader: () => import ("./EditSnippet"), loading });
const SpeedCodingPage = Loadable({ loader: () => import ("./SpeedCodePage"), loading });
const SnippetsPage = Loadable({ loader: () => import ("./SnippetsPage"), loading });

const Pages = () => (
  <React.Fragment>
    <Route exact path={routes.LANDING} component={withLayout(Landing)}/>
    <Route exact path={routes.HOME} component={withLayout(Home)}/>
    <Route exact path={routes.SIGN_UP} component={withLayout(SignUp)}/>
    <Route exact path={routes.SIGN_IN} component={withLayout(SignIn)}/>
    <Route
      exact
      path={routes.PASSWORD_FORGET}
      component={withLayout(PasswordForget)}
    />
    <Route
      exact
      path="/account/change-password"
      component={withLayout(PasswordChange)}
    />
    <Route exact path={routes.ACCOUNT} component={withLayout(Account)}/>
    <Route exact path={routes.ADD_SNIPPET} component={withLayout(AddSnippet)}/>
    <Route exact path={"/about"} component={withLayout(About)}/>
    <Route exact path={"/my-snippets"} component={withLayout(MySnippets)}/>
    <Route exact path={"/how-to-use"} component={withLayout(HowTo)}/>
    <Route
      exact
      path={"/snippets/edit/public/:key"}
      component={withLayout(props => (
        <EditSnippet {...props} privacy="public"/>
      ))}
    />
    <Route
      exact
      path={"/snippets/edit/private/:key"}
      component={withLayout(props => (
        <EditSnippet {...props} privacy="private"/>
      ))}
    />
    <Route
      exact
      path={routes.RANDOM_EXAMPLE}
      component={withLayout(props => <SpeedCodingPage {...props} random/>)}
    />
    <Route exact path={routes.SNIPPETS} component={withLayout(SnippetsPage)}/>
    <Route
      exact
      path={routes.SNIPPETS + "/me/:title"}
      component={withLayout(props => (
        <SpeedCodingPage
          ident={props.match.params.ident}
          isPrivate={"private"}
          {...props}
        />
      ))}
    />
    <Route
      exact
      path={routes.SNIPPETS + "/public/:title"}
      component={withLayout(props => (
        <SpeedCodingPage {...props} ident={props.match.params.title}/>
      ))}
    />
    <Route exact path="/categories" component={withLayout(CategoryListPage)}/>
    <Route exact path="/add-category" component={withLayout(AddCategoryPage)}/>
    <Route
      exact
      path="/category/:category"
      component={withLayout(props => (
        <CategoryDetailPage category={props.match.params.category} {...props} />
      ))}
    />
  </React.Fragment>
);
export default Pages;
